// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_EDIT_CUOTA,
} from './constants';

export function editCuota(id) {
  return {
    type: SIMULADOR_FINANCIERO_EDIT_CUOTA,
    id: id
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_EDIT_CUOTA:
      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        let cuotas = state.editLineaData.datosFinancieros.cuotas;
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.showEdit = false;
            cuota.showDelete = false;
          }
        });
        // let cuotasPreviousValues = state.editLineaData.datosFinancieros.cuotasPreviousValues;
        // let cuotaAux = cuotas.find((cuota) => {
        //   return cuota.id === action.id;
        // })
        // cuotasPreviousValues.map((cuota) => {
        //   if (action.id === cuotaAux.id) {
        //     cuota.plazo = cuotaAux.plazo;
        //     cuota.montoMax = cuotaAux.montoMax;
        //     cuota.tna = cuotaAux.tna;
        //     cuota.valorCuotaPromedio = cuotaAux.valorCuotaPromedio;
        //     cuota.porcMaxFinanciar = cuotaAux.porcMaxFinanciar;
        //     cuota.quebranto = cuotaAux.quebranto;
        //     cuota.gastos = cuotaAux.gastos;
        //     cuota.cft = cuotaAux.cft;
        //   }
        // })

        editLineaData.datosFinancieros.cuotas = cuotas;
        //editLineaData.datosFinancieros.cuotasPreviousValues = cuotasPreviousValues;

        return {
          ...state,
          editLineaData: editLineaData
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        let cuotas = state.altaNuevaLinea.datosFinancieros.cuotas;
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.showEdit = false;
            cuota.showDelete = false;
          }
        });
        let cuotasPreviousValues = state.altaNuevaLinea.datosFinancieros.cuotasPreviousValues;
        let cuotaAux = cuotas.find((cuota) => {
          return cuota.id === action.id;
        })
        cuotasPreviousValues.forEach((cuota) => {
          if (action.id === cuotaAux.id) {
            cuota.plazo = cuotaAux.plazo;
            cuota.montoMax = cuotaAux.montoMax;
            cuota.tna = cuotaAux.tna;
            cuota.valorCuotaPromedio = cuotaAux.valorCuotaPromedio;
            cuota.porcMaxFinanciar = cuotaAux.porcMaxFinanciar;
            cuota.quebranto = cuotaAux.quebranto;
            cuota.gastos = cuotaAux.gastos;
            cuota.cft = cuotaAux.cft;
          }
        })

        altaNuevaLinea.datosFinancieros.cuotas = cuotas;
        altaNuevaLinea.datosFinancieros.cuotasPreviousValues = cuotasPreviousValues;

        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea
        };
      }

    default:
      return state;
  }
}
